<template>
    <div id="my">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                        <li><a href="index.html">首頁</a></li>
                        <li><a href="member_profile.html">我的</a></li>
                        <li>我的帳戶</li>
                    </ul>
                </div>
            </div>
	
            <div class="bodyContent user">
                <div class="container">
                    <div class="row no-gutters">
                        <div class="col-md-3">
							<nav class="sideNav">
                                <!-- <MyMenu></MyMenu> -->
							</nav>
                        </div>

                        <!-- <MyContent id="my-content" ></MyContent> -->
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
// import MyMenu from "./mySubviews/myMenu";
// import MyContent from "./mySubviews/myContent";
export default {
  mounted() {
    // 會員header fixed
    var stickyHeader = $(".sideNav").offset().top;

    $(window).scroll(function() {
      if ($(window).scrollTop() > stickyHeader) {
        $(".sideNav").addClass("affix");
      } else {
        $(".sideNav").removeClass("affix");
      }
    });
  },
  components: {
    // MyMenu,
    // MyContent
  }
};
</script>


<style>
@import '../../assets/css/user.css';
@import '../../assets/css/user_rwd.css';
/* @import '@/assets/css/user_rwd.css'; */
#my{
    background: #fbfbfb;
}

.user{
    padding: 18px;
}

</style>



// WEBPACK FOOTER //
// src/components/views/My.vue